export default "__VITE_ASSET__BGWVqFKM__"